import React, { useState } from "react";
import { useDiaryContext } from "../../../../../hooks/useDiaryContext";
import { useNotificationsContext } from "../../../../../hooks/useNotificationsContext";
import Loading from "../../../../../utils/Loading";
import CheckIn from "./CheckIn/CheckIn";
import ManageFooter from "./Footer/ManageFooter";
import RunningLate from "./RunningLate/RunningLate";
import Stages from "./Stages/Stages";
import { CustomerRequest } from "./CustomerRequest/CustomerRequest";
import { Offers } from "./Offers/Offers";
import { CustomFields } from "./CustomFields/CustomFields";
import { Alert, AlertDescription } from "../../../../ui/alert";
import { Info } from "lucide-react";
import { ViewBookingStatusEnum } from "collins-js-sdk";
import { updateBooking } from "./SelectedBookingManageController";
import { addOrUpdateBooking } from "../../../../../APIs/Booking/UpdateBooking";

const SelectedBookingManage = () => {
  const diaryContext = useDiaryContext();
  const { selectedBooking, bookings, setDiaryContext } = diaryContext;
  const notificationsContext = useNotificationsContext();
  const [isReopenLoading, setIsReopenLoading] = useState(false);

  if (!selectedBooking) {
    return <Loading />;
  }

  const handleUndo = async () => {
    if (!bookings) return;
    setIsReopenLoading(true);

    try {
      const updatedBookingForAPI = {
        ...selectedBooking,
        status: ViewBookingStatusEnum.InProgress
      };

      const response = await addOrUpdateBooking({
        booking: updatedBookingForAPI
      });

      if (response && !response.unsaved && response.id) {
        const { updatedBookings } = updateBooking({
          selectedBooking,
          bookings,
          bookingPropsToSave: { status: ViewBookingStatusEnum.InProgress }
        });
        setDiaryContext({ bookings: updatedBookings });
      } else {
        notificationsContext.addNotification({
          heading: "Failed to reopen booking",
          autoClose: 4000,
          toastType: "error"
        });
      }
    } catch {
      notificationsContext.addNotification({
        heading: "Failed to reopen booking",
        autoClose: 4000,
        toastType: "error"
      });
    } finally {
      setIsReopenLoading(false);
    }
  };

  const arrived = (selectedBooking.currentStage ?? "") !== "";

  return (
    <div className="ManageBooking flex flex-col h-full min-h-0 max-h-full">
      <div className="ManageBooking-content m-[var(--panelPadding)] grow min-h-0 overflow-visible max-h-[calc(100vh-400px)]">
        {selectedBooking.status === ViewBookingStatusEnum.Rejected && (
          <Alert>
            <Info className="h-4 w-4" />
            <AlertDescription>
              This booking has been cancelled.{" "}
              <button
                onClick={handleUndo}
                className="ManageBooking-undoButton underline cursor-pointer bg-transparent border-none p-0 font-[inherit] text-[inherit] disabled:opacity-50 disabled:no-underline disabled:pointer-events-none"
                disabled={isReopenLoading}
              >
                Undo.
              </button>
            </AlertDescription>
          </Alert>
        )}
        <CustomerRequest note={selectedBooking.notes} />
        <CustomFields showHeader={!selectedBooking.notes} />
        <Offers offer={selectedBooking.offer} />
        <CheckIn />
        {arrived ? <Stages /> : <RunningLate />}
      </div>
      <ManageFooter handleUndo={handleUndo} isReopenLoading={isReopenLoading} />
    </div>
  );
};

export default SelectedBookingManage;
